export default "__VITE_ASSET__CLZb1ygb__"